import FormattedMessageWrapper from 'components/App/FormattedMessageWrapper';
import RoleModel               from 'models/RoleModel';

export const ROLE_SUPER_ADMIN = 'ROLE_SUPER_ADMIN';
export const ROLE_ADMIN = 'ROLE_ADMIN';

export const ROLE_SUPPORT_ASTECH = 'ROLE_SUPPORT_ASTECH';
export const ROLE_SECURITY_OFFICER = 'ROLE_SECURITY_OFFICER';
export const ROLE_COORDINATOR_SPS = 'ROLE_COORDINATOR_SPS';
export const ROLE_EXHIBITION_CENTER_SERVICE = 'ROLE_EXHIBITION_CENTER_SERVICE';

export const ROLE_ORGANIZER = 'ROLE_ORGANIZER';
export const ROLE_STANDIST = 'ROLE_STANDIST';

export const rolesBack = [
  ROLE_ADMIN,
  ROLE_COORDINATOR_SPS,
  ROLE_EXHIBITION_CENTER_SERVICE,
  ROLE_SECURITY_OFFICER,
  ROLE_SUPPORT_ASTECH,
];

export const rolesBackWithShows = [
  ROLE_COORDINATOR_SPS,
  ROLE_EXHIBITION_CENTER_SERVICE,
  ROLE_SECURITY_OFFICER,
  ROLE_SUPPORT_ASTECH,
];

export const getRoleIntlLabel = (role: RoleModel) => {
  switch (role.reference) {
    case ROLE_SUPER_ADMIN:
      return <FormattedMessageWrapper id="Super administrateur" />;
    case ROLE_ADMIN:
      return <FormattedMessageWrapper id="Administrateur" />;
    case ROLE_SUPPORT_ASTECH:
      return <FormattedMessageWrapper id="Gestionnaire Salon" />;
    case ROLE_SECURITY_OFFICER:
      return <FormattedMessageWrapper id="Chargé de sécurité" />;
    case ROLE_COORDINATOR_SPS:
      return <FormattedMessageWrapper id="Coordonateur SPS" />;
    case ROLE_EXHIBITION_CENTER_SERVICE:
      return <FormattedMessageWrapper id="Service du parc des expositions" />;
    case ROLE_ORGANIZER:
      return <FormattedMessageWrapper id="Organisateur" />;
    case ROLE_STANDIST:
      return <FormattedMessageWrapper id="Standiste" />;
    default:
      return null;
  }
};
